import { useState, useEffect } from 'react'

const useIsTouchDevice = (): boolean => {
  const [isTouch, setIsTouch] = useState<boolean>(false)

  useEffect(() => {
    // Check for touch capabilities
    const touchCapable = 'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      (window.matchMedia?.('(pointer: coarse)').matches)

    setIsTouch(touchCapable)
  }, [])

  return isTouch
}

export default useIsTouchDevice
